'use client';
import { GameType, dateToSimpleDate } from '@puzzlio/core';
import { GAME_CONFIG } from '@/app/games/config';
import { useIsInIntroMode } from '@/app/providers/ProgressProvider';

/**
 * Destination for a "play this game" link. While the player hasn't graduated yet it points at the guided
 * tutorial; once they've graduated it points at today's daily puzzle.
 */
export function useIntroAwareGameURL(gameType: GameType): string {
  const inIntroMode = useIsInIntroMode(gameType);
  if (inIntroMode) return GAME_CONFIG[gameType].tutorialURL;
  return GAME_CONFIG[gameType].gameURL(dateToSimpleDate(new Date()));
}
